(function () {
  const section = document.querySelector('[data-fc-products]');
  if (!section) return;

  // IntersectionObserver: fade-up animation when section enters viewport
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.setAttribute('data-inview', 'true');
          io.unobserve(section);
        }
      });
    }, { threshold: 0.15 });
    io.observe(section);
  } else {
    section.setAttribute('data-inview', 'true');
  }

  // Tab switching: filter products by category, show only first 4
  const tabs = section.querySelectorAll('[data-fc-tab]');
  const cards = section.querySelectorAll('[data-fc-product]');

  function setActive(tab) {
    tabs.forEach((t) => {
      t.setAttribute('data-active', t.dataset.fcTab === tab ? 'true' : 'false');
    });
    // Only available products are rendered (Liquid skips market-unavailable
    // ones), so in some markets a category may have fewer than 4 cards. Always
    // show 4 tiles: first fill with category matches, then backfill with any
    // remaining available products so the 4-up never looks short. (Falls back
    // to however many exist if the market truly has < 4 products.)
    let shown = 0;
    const all = Array.prototype.slice.call(cards);
    // Pass 1: category matches, up to 4
    all.forEach((c) => {
      const cats = (c.dataset.fcCategories || '').split(',');
      if (cats.indexOf(tab) >= 0 && shown < 4) {
        c.removeAttribute('hidden');
        shown++;
      } else {
        c.setAttribute('hidden', '');
      }
    });
    // Pass 2: backfill from other available products until we reach 4
    if (shown < 4) {
      all.forEach((c) => {
        if (shown >= 4) return;
        if (c.hasAttribute('hidden')) {
          c.removeAttribute('hidden');
          shown++;
        }
      });
    }
  }

  tabs.forEach((t) => {
    t.addEventListener('click', () => setActive(t.dataset.fcTab));
  });

  setActive('popular');
})();
